// extracted by mini-css-extract-plugin
export var btn = "Features-module--btn--8c5c1";
export var btnOutlinePrimary = "Features-module--btn-outline-primary--1f182";
export var btnPrimary = "Features-module--btn-primary--426f0";
export var content = "Features-module--content--cfd3f";
export var formSelect = "Features-module--form-select--3ddc2";
export var inner = "Features-module--inner--79ae7";
export var media = "Features-module--media--3c689";
export var points = "Features-module--points--7568d";
export var row = "Features-module--row--32afe";
export var rowReversed = "Features-module--rowReversed--67c9b";
export var section = "Features-module--section--74c6e";
export var sectionHeading = "Features-module--sectionHeading--dfc11";
export var title = "Features-module--title--0eb27";